import { Button, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { NewTabLink } from "components/NewTabLink";
import { useWriterComponentState } from "hooks";

import { ClientAppEvent } from "../../../constants";

interface Props {
  pendingRequest: FollowShipperRequestAndResponse;
  onRefetchFollowers: VoidFunction;
}

export function ShipperPendingRequestTableRow(props: Props) {
  const { pendingRequest, onRefetchFollowers } = props;
  const posthog = usePostHog();

  const { write, error, loading } = useWriterComponentState({
    errorMessage:
      "Failed to delete request. Please contact us if the problem persists.",
    writeConfig: {
      method: "delete",
      url: `/follow_requests/${pendingRequest.request.id}`,
    },
  });

  const onDeleteRequest = () => {
    write(() => {
      posthog?.capture(ClientAppEvent.SHIPPER_PENDING_REQUEST_DELETED, {
        request_id: pendingRequest.request.id,
      });
      onRefetchFollowers();
    });
  };

  return (
    <TableRow key={pendingRequest.request.id}>
      <TableCell>
        {pendingRequest.request.type === "SHIPPER_FOLLOW_REQUEST" ? (
          <Typography variant="body1">
            {pendingRequest.request.target_role?.user.first_name}{" "}
            {pendingRequest.request.target_role?.user.last_name}
          </Typography>
        ) : (
          <Typography variant="body1">
            {pendingRequest.request.target_email}
          </Typography>
        )}
      </TableCell>
      <TableCell>
        {pendingRequest.request.type === "SHIPPER_FOLLOW_REQUEST" &&
        pendingRequest.request.target_role?.company ? (
          <NewTabLink
            href={`/companies/${pendingRequest.request.target_role.company.id}/profile`}
          >
            <Typography variant="body1">
              {pendingRequest.request.target_role.company.name}
            </Typography>
          </NewTabLink>
        ) : (
          <Typography variant="body1" color="text.secondary">
            -
          </Typography>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(pendingRequest.request.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <Stack>
          <LoadingWrappedNode loading={loading}>
            <Button variant="outlined" size="small" onClick={onDeleteRequest}>
              Remove from Network
            </Button>
            <ErrorTypography error={error} />
          </LoadingWrappedNode>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
